<template>
  <div class="modal-content ion-padding ion-text-center">
    <modal-close />
    <roodie fillOuter="#5E58BE" :expression="'happy'" />
    <div class="u-color-primary u-bold">
      <div class="u-medium ion-margin-top">
        Experten helfen bei der Suche
      </div>
      <div class="u-xxlarge ion-margin-top">
        0261 - 988 979 13<sup>*</sup><br />
        <ion-icon style="font-size: 40px" :icon="call"></ion-icon>
      </div>
      <ion-button
        class="ion-margin-top gtm-call-betterdoc"
        fill="outline"
        @click="window.open('tel:+4926198897913')"
        >Jetzt anrufen</ion-button
      >
      <div class="ion-margin-top">
        * Sie verlassen jetzt die Roodie App und werden zu einem/r Experten/in
        von Quality Smile weitergeleitet.
      </div>
    </div>
  </div>
</template>

<script>
import Roodie from "@lib/components/svg/Roodie";
import { IonButton, IonIcon } from "@ionic/vue";
import { call } from "ionicons/icons";
import ModalClose from "@lib/components/ModalClose";

export default {
  components: {
    Roodie,
    IonButton,
    IonIcon,
    ModalClose,
  },
  setup() {
    return { call };
  },
  data() {
    return {
      window: window,
    };
  },
};
</script>

<style></style>
